function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3424.8826,
    y1: 3656.1157,
    x2: 1358.1902,
    y2: 1425.3999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M3137.271,2392.462c-283.314,669.324-1051.051,905.324-1637.008,856.307 c-159.99-13.384-462.013,11.178-713.359-229.063c-482.691-461.368-408.352-1425.756,53.722-1993.535 c59.506-73.118,471.394-563.002,1113.245-556.445c469.929,4.801,799.767,273.108,839.874,306.534 c50.666,42.226,162.415,142.568,263.127,301.755C3293.512,1452.048,3314.314,1974.201,3137.271,2392.462z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M3094.81,2767.607h-443.697V1682.148h510.262v1018.893 C3161.375,2737.804,3131.573,2767.607,3094.81,2767.607z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016045738826928338430000005267256723241834174_",
    gradientUnits: "userSpaceOnUse",
    x1: 3772.9688,
    y1: 636.5765,
    x2: 3483.1526,
    y2: 926.3928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016045738826928338430000005267256723241834174_)"
    },
    d: "M3229.717,1775.953h-602.902 l-110.342-489.126h584.156l152.837,448.1C3261.514,1754.066,3248.844,1775.953,3229.717,1775.953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159433771319073155040000017131275133532641940_",
    gradientUnits: "userSpaceOnUse",
    x1: 3509.6331,
    y1: 254.428,
    x2: 3226.5566,
    y2: 652.0833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159433771319073155040000017131275133532641940_)"
    },
    d: "M3103.812,1293.433l-621.322,18.403 l-16.533-60.214l594.307-11.698c22.293,0,40.365,14.551,40.365,32.501L3103.812,1293.433z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165217955136393428720000004972322352448341377_",
    gradientUnits: "userSpaceOnUse",
    x1: 2761.9734,
    y1: 2224.8774,
    x2: 3053.5518,
    y2: 2224.8774
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165217955136393428720000004972322352448341377_)"
    },
    d: "M3052.429,2472.791h-289.332 c-0.62,0-1.123-0.503-1.123-1.123v-493.581c0-0.62,0.503-1.123,1.123-1.123h289.332c0.62,0,1.123,0.503,1.123,1.123v493.581 C3053.552,2472.288,3053.049,2472.791,3052.429,2472.791z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127723591932245637840000004148251356252456346_",
    gradientUnits: "userSpaceOnUse",
    x1: 4043.1326,
    y1: 821.0343,
    x2: 2461.1409,
    y2: 2666.6912
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127723591932245637840000004148251356252456346_)"
    },
    d: "M2895.818,2445.99h-111.959 c-0.345,0-0.624-0.28-0.624-0.624V2004.39c0-0.345,0.279-0.624,0.624-0.624h111.959c0.345,0,0.624,0.28,0.624,0.624v440.976 C2896.442,2445.71,2896.163,2445.99,2895.818,2445.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086659078960406675060000004443408565926060976_",
    gradientUnits: "userSpaceOnUse",
    x1: 4121.2744,
    y1: 888.3593,
    x2: 2539.2834,
    y2: 2734.0149
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086659078960406675060000004443408565926060976_)"
    },
    d: "M3031.667,2445.99h-111.959 c-0.345,0-0.624-0.28-0.624-0.624V2004.39c0-0.345,0.28-0.624,0.624-0.624h111.959c0.345,0,0.624,0.28,0.624,0.624v440.976 C3032.291,2445.71,3032.011,2445.99,3031.667,2445.99z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1090.724,2767.607h463.939V1682.148h-510.262v1039.136 C1044.402,2746.867,1065.141,2767.607,1090.724,2767.607z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012434747224623724360000010087128810801274796_",
    gradientUnits: "userSpaceOnUse",
    x1: 1176.0732,
    y1: 327.3669,
    x2: 1243.4718,
    y2: 873.2993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012434747224623724360000010087128810801274796_)"
    },
    d: "M976.06,1775.953h602.902 l117.297-489.126h-591.112l-152.838,448.1C944.262,1754.066,956.933,1775.953,976.06,1775.953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182506121232468701920000003843712423529783219_",
    gradientUnits: "userSpaceOnUse",
    x1: 1264.8932,
    y1: 2153.4116,
    x2: 1693.2727,
    y2: -5.9681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182506121232468701920000003843712423529783219_)"
    },
    d: "M1105.147,1293.526l664.336,5.001 l2.742-58.603l-623.599-0.001c-24.013,0-43.48,14.551-43.48,32.501V1293.526z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.89
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1153.348,2472.791h289.332c0.62,0,1.123-0.503,1.123-1.123v-493.581 c0-0.62-0.503-1.123-1.123-1.123h-289.332c-0.62,0-1.123,0.503-1.123,1.123v493.581 C1152.225,2472.288,1152.728,2472.791,1153.348,2472.791z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053536573781629560350000017968753034246921383_",
    gradientUnits: "userSpaceOnUse",
    x1: 1400.1583,
    y1: 1796.4922,
    x2: 1332.0902,
    y2: 2648.6011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053536573781629560350000017968753034246921383_)"
    },
    d: "M1309.958,2445.99h111.959 c0.345,0,0.624-0.28,0.624-0.624V2004.39c0-0.345-0.279-0.624-0.624-0.624h-111.959c-0.345,0-0.624,0.28-0.624,0.624v440.976 C1309.334,2445.71,1309.614,2445.99,1309.958,2445.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046333447322006379860000015449533071059599270_",
    gradientUnits: "userSpaceOnUse",
    x1: 1265.2576,
    y1: 1784.621,
    x2: 1197.1895,
    y2: 2636.7297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046333447322006379860000015449533071059599270_)"
    },
    d: "M1174.109,2445.99h111.959 c0.345,0,0.624-0.28,0.624-0.624V2004.39c0-0.345-0.279-0.624-0.624-0.624h-111.959c-0.345,0-0.624,0.28-0.624,0.624v440.976 C1173.485,2445.71,1173.765,2445.99,1174.109,2445.99z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2094.382,1003.247c0,0-691.772,576.051-708.91,576.051V2762.83 c0,29.097,21.385,52.685,47.764,52.685h1336.134c18.735,0,33.923-16.753,33.923-37.418V1579.298L2094.382,1003.247z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168821190685048625360000000993580604338004889_",
    gradientUnits: "userSpaceOnUse",
    x1: 2042.7146,
    y1: 2433.4292,
    x2: 2071.1301,
    y2: 2852.5608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168821190685048625360000000993580604338004889_)"
    },
    d: "M2282.482,2767.607H1842.89v-79.084 c0-1.751,1.419-3.17,3.17-3.17h433.252c1.751,0,3.17,1.419,3.17,3.17V2767.607z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114058939059252803460000002660688341498547636_",
    gradientUnits: "userSpaceOnUse",
    x1: 2046.1251,
    y1: 2536.0691,
    x2: 2074.5408,
    y2: 2955.2007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114058939059252803460000002660688341498547636_)"
    },
    d: "M2282.482,2819.941H1842.89v-79.084 c0-1.751,1.419-3.17,3.17-3.17h433.252c1.751,0,3.17,1.419,3.17,3.17V2819.941z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043441610820336277970000016282889927216422331_",
    gradientUnits: "userSpaceOnUse",
    x1: 2070.563,
    y1: 568.4451,
    x2: 2060.4084,
    y2: 2883.6357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043441610820336277970000016282889927216422331_)"
    },
    d: "M2212.705,2685.352h-300.038v-642.065 c0-1.966,1.594-3.56,3.56-3.56h292.918c1.966,0,3.56,1.594,3.56,3.56V2685.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2191.52,1996.271h-257.667c-11.7,0-21.185-10.462-21.185-23.368v-20.411 c0-12.277,8.614-22.461,19.717-23.312l257.667-19.743c12.249-0.939,22.654,9.769,22.654,23.312v40.154 C2212.705,1985.81,2203.22,1996.271,2191.52,1996.271z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000189604332946596380000000111700608821547164_",
    gradientUnits: "userSpaceOnUse",
    x1: 2696.5176,
    y1: 1091.4778,
    x2: 2177.1042,
    y2: 2433.293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000000189604332946596380000000111700608821547164_)"
    },
    d: "M2450.973,1709.464 h-2.851c-74.103,0-138.978,57.868-138.978,139.605v147.202h141.829V1709.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029022502205012868710000009356558088783005570_",
    gradientUnits: "userSpaceOnUse",
    x1: 2820.4282,
    y1: 1137.235,
    x2: 2297.2166,
    y2: 2488.8625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000029022502205012868710000009356558088783005570_)"
    },
    d: "M2309.144,2039.727 v433.064c0,14.583,15.519,37.19,28.739,37.19h113.09v-470.254H2309.144z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069363355584293682390000013589768217331703230_",
    gradientUnits: "userSpaceOnUse",
    x1: 2829.3308,
    y1: 1140.0607,
    x2: 2305.4009,
    y2: 2493.5435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000069363355584293682390000013589768217331703230_)"
    },
    d: "M2489.698,1709.464 h-7.208v286.807h141.829V1849.07C2624.319,1767.333,2563.802,1709.464,2489.698,1709.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111913187601784117660000001234820388297333386_",
    gradientUnits: "userSpaceOnUse",
    x1: 2963.5508,
    y1: 1200.4092,
    x2: 2441.165,
    y2: 2549.9026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#SVGID_00000111913187601784117660000001234820388297333386_)"
    },
    d: "M2482.49,2509.981 h117.447c13.22,0,24.382-22.607,24.382-37.19v-433.064H2482.49V2509.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048477990120820025340000003316479857292382870_",
    gradientUnits: "userSpaceOnUse",
    x1: 1615.2181,
    y1: 967.855,
    x2: 1587.0972,
    y2: 2610.1165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048477990120820025340000003316479857292382870_)"
    },
    d: "M1669.794,1709.464h-2.851 c-74.104,0-138.978,57.868-138.978,139.605v147.202h141.829V1709.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018923056245102689350000012590751252379166871_",
    gradientUnits: "userSpaceOnUse",
    x1: 1621.2615,
    y1: 967.772,
    x2: 1593.1281,
    y2: 2610.7581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018923056245102689350000012590751252379166871_)"
    },
    d: "M1527.965,2039.727v433.064 c0,14.583,15.519,37.19,28.739,37.19h113.09v-470.254H1527.965z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024720033443600850420000003578927682343291574_",
    gradientUnits: "userSpaceOnUse",
    x1: 1787.339,
    y1: 970.2779,
    x2: 1759.1952,
    y2: 2613.8635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024720033443600850420000003578927682343291574_)"
    },
    d: "M1708.519,1709.464h-7.208v286.807 h141.828V1849.07C1843.14,1767.333,1782.623,1709.464,1708.519,1709.464z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096026612564566249350000015365647271354511289_",
    gradientUnits: "userSpaceOnUse",
    x1: 1794.2336,
    y1: 971.1484,
    x2: 1766.1031,
    y2: 2613.9602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096026612564566249350000015365647271354511289_)"
    },
    d: "M1701.312,2509.981h117.447 c13.22,0,24.382-22.607,24.382-37.19v-433.064h-141.828V2509.981z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2636.59,2537.029h-341.413c-19.577,0-35.503-17.568-35.503-39.163v-652.022 c0-103.109,76.051-186.993,169.529-186.993h73.362c93.478,0,169.528,83.884,169.528,186.993v652.022 C2672.093,2519.461,2656.167,2537.029,2636.59,2537.029z M2429.203,1662.479c-91.666,0-166.241,82.257-166.241,183.366v652.022 c0,19.595,14.452,35.535,32.215,35.535h341.413c17.763,0,32.215-15.941,32.215-35.535v-652.022 c0-101.109-74.574-183.366-166.24-183.366H2429.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1855.564,2537.029h-341.412c-19.577,0-35.503-17.568-35.503-39.163v-652.022 c0-103.109,76.049-186.993,169.527-186.993h73.362c93.479,0,169.529,83.884,169.529,186.993v652.022 C1891.067,2519.461,1875.141,2537.029,1855.564,2537.029z M1648.176,1662.479c-91.665,0-166.24,82.257-166.24,183.366v652.022 c0,19.595,14.452,35.535,32.215,35.535h341.412c17.763,0,32.215-15.941,32.215-35.535v-652.022 c0-101.109-74.575-183.366-166.241-183.366H1648.176z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029763512955868511690000013365439172673326004_",
    gradientUnits: "userSpaceOnUse",
    x1: 1817.457,
    y1: 2393.3223,
    x2: 2540.1997,
    y2: 2174.1675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029763512955868511690000013365439172673326004_)"
    },
    d: "M1923.275,2685.352h-7.25 c-2.825,0-5.114-2.526-5.114-5.641v-635.183c0-2.651,1.948-4.8,4.352-4.8h8.012V2685.352z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022536855948028198010000010949400588894390145_",
    gradientUnits: "userSpaceOnUse",
    x1: 2327.748,
    y1: 1377.822,
    x2: 2708.1895,
    y2: 658.191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2404.81,
    y: 1015.827,
    style: {
      fill: "url(#SVGID_00000022536855948028198010000010949400588894390145_)"
    },
    width: 117.275,
    height: 210.622
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108271391621775067570000008045911877571742089_",
    gradientUnits: "userSpaceOnUse",
    x1: 2453.905,
    y1: 726.8804,
    x2: 2487.583,
    y2: 1551.9948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108271391621775067570000008045911877571742089_)"
    },
    d: "M2560.735,1049.955h-189.556v-58.583 c0-3.366,2.729-6.096,6.096-6.096h174.182c5.124,0,9.278,4.154,9.278,9.278V1049.955z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097492754419755802620000007686963410184224130_",
    gradientUnits: "userSpaceOnUse",
    x1: 2337.604,
    y1: 861.7744,
    x2: 2971.1563,
    y2: -964.7421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097492754419755802620000007686963410184224130_)"
    },
    d: "M1342.008,1639.692l752.375-636.445 l714.175,611.034c25.958,22.209,64.034,6.655,70.615-28.847l10.017-54.044l-794.807-667.838l-769.339,648.166 c-13.775,11.605-18.773,31.964-12.19,49.651L1342.008,1639.692z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1378.34,2431.693c-8.88,30.268-45.786,41.629-70.411,21.916 c-135.875-108.768-492.23-451.036-496.661-1051.857c-3.741-507.366-53.984-782.125-85.436-905.275 c-6.65-26.041,23.809-45.436,44.625-28.435C1000.121,655.618,1700.118,1334.935,1378.34,2431.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1335.728,2434.593c-0.624,0.472-1.299,0.889-2.029,1.245 c-6.108,2.99-13.485,0.461-16.474-5.647c-3.389-6.926-339.311-700.631-376.381-1405.854 c-0.354-6.786,4.86-12.583,11.654-12.946c6.793-0.355,12.587,4.86,12.947,11.654 c36.798,700.09,370.538,1389.441,373.903,1396.32C1341.982,2424.745,1340.334,2431.108,1335.728,2434.593z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M449.424,957.512c-6.743-15.527,14.118-30.434,30.137-21.633 c162.658,89.361,565.795,372.146,589.761,989.458c30.069,774.51,262.118,1017.125,519.313,1144.192 c0,0-493.958,96.351-740.498-147.829C242.825,2322.179,569.326,1233.595,449.424,957.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M600.05,1173.87c32.956,80.865,64.03,162.337,91.578,244.838 c28.048,82.337,53.174,165.509,75.244,249.378c21.694,83.952,41.555,168.328,57.226,253.5 c16.113,85.087,27.974,170.87,39.536,257.05c12.11,86.049,23.745,172.821,45.68,258.359 c21.799,85.379,55.79,169.334,106.716,244.587c12.719,18.75,25.893,37.353,40.234,55.036 c13.957,17.94,28.862,35.304,44.132,52.412c30.751,34.083,64.258,66.326,100.488,96.128 c72.657,59.445,156.228,108.719,245.412,147.083c9.387,4.038,21.148,0.5,26.272-7.902c5.03-8.249,1.787-18.122-7.219-22.299 l-0.064-0.03c-21.357-9.88-42.545-19.968-63.094-30.868c-10.386-5.303-20.455-11.01-30.654-16.543 c-9.925-5.874-20.136-11.402-29.826-17.547c-39.261-23.98-76.399-50.424-110.964-79.234 c-69.398-57.248-128.791-124.285-177.591-196.094c-23.927-36.177-44.66-73.967-61.897-113.169 c-17.204-39.219-30.906-79.808-41.916-121.229c-22.039-82.889-34.374-168.654-47.199-254.59 c-12.956-85.935-26.659-172.183-44.446-257.621c-8.759-42.74-18.407-85.299-28.935-127.646 c-5.122-21.205-10.72-42.299-16.273-63.4c-5.788-21.044-11.711-42.052-17.832-63.004 c-24.664-83.765-52.292-166.7-82.935-248.623c-31.102-81.773-64.729-162.687-101.946-242.173 c-1.065-2.273-4.086-3.266-6.75-2.22C600.441,1169.065,599.147,1171.643,600.05,1173.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174587574141040710540000010248567844444228023_",
    gradientUnits: "userSpaceOnUse",
    x1: 1494.858,
    y1: 1209.3942,
    x2: 1708.7775,
    y2: 2368.1257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000174587574141040710540000010248567844444228023_)"
    },
    points: "1434.971,1630.766  1487.735,1899.493 1754.991,1875.507 1703.267,1592.517  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072271763696053594130000009558107434234542991_",
    gradientUnits: "userSpaceOnUse",
    x1: 719.1003,
    y1: 688.7446,
    x2: 1422.2086,
    y2: 1443.8212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072271763696053594130000009558107434234542991_)"
    },
    d: "M1296.131,1042.179 c0,0-26.754,112.601-98.798,50.471c-72.046-62.13-161.13-154.029-261.872-75.085c-100.743,78.945,18.757,144.313,18.757,144.313 s-45.916-23.499-80.48,13.601c-9.935,10.662-25.805,12.625-37.636,4.116c-11.158-8.027-26.574-12.322-45.18-0.255 c-14.637,9.493-55.373,101.902-18.136,265.757c22.176,97.581,86.662,378.656,307.401,432.055 c144.131,34.868,267.205-48.572,278.018-56.146c120.896-84.686,143.925-214.227,147.689-237.815 c-6.746-25.99-38.534-158.767,38.505-266.61c17.515-24.519,68.562-87.816,147.297-99.577c16.937-2.53,34.584,0.82,59.147,8.774 c0,0,20.701,115.839,97.279,111.531c0,0-7.548-29.122,22.222-46.16c28.53-16.331,96.684-100.018-19-173.988 c-9.184-5.874-13.987-16.525-13.016-27.382c3.131-35.028-4.756-115.239-123.058-181.101 c-150.345-83.698-254.514-67.035-310.198,16.117c-4.038,6.028-10.393,10.109-17.495,11.605 C1363.698,941.441,1309.019,961.699,1296.131,1042.179z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149384206339654122850000000085403362548781190_",
    gradientUnits: "userSpaceOnUse",
    x1: 1429.6091,
    y1: 972.0604,
    x2: 1647.0889,
    y2: 123.5327,
    gradientTransform: "matrix(0.9977 0.0681 -0.0681 0.9977 345.4232 35.2827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149384206339654122850000000085403362548781190_)"
    },
    d: "M1337.958,1407.384 c0,0,37.517,288.626,205.768,338.25c168.255,49.625,243.338-212.245,254.125-230.581c0,0,36.67,21.574,48.752-15.745 c12.083-37.317,66.015-128.991-19.407-134.82c0,0,25.461-93.618,0.226-143.018c-25.237-49.4-74.411-167.184-199.743-147.129 C1502.35,1094.393,1347.674,1265.013,1337.958,1407.384z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112601972436098707720000006237124778174111152_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.424,
    y1: 488.6519,
    x2: 1632.0243,
    y2: 1266.809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112601972436098707720000006237124778174111152_)"
    },
    d: "M1814.608,1092.728 c-9.47-5.4-14.808-15.794-14.39-26.685c1.348-35.142-10.603-114.849-132.097-174.618 c-154.402-75.954-257.59-54.022-308.979,31.851c-3.727,6.225-9.866,10.624-16.883,12.479 c-23.594,6.247-77.174,29.256-85.958,110.287c0,0-9.52,51.369-38.553,67.351c69.487,57.757,100.317,260.315,101.724,263.027 c21.764,5.284,101.987,16.694,198.715-68.939c115.958-102.655,125.799-121.514,201.566-101.171 c0,0,54.677,114.199,130.937,106.006c0,0-20.092-23.591,8.775-42.119C1887.128,1252.438,1933.9,1160.727,1814.608,1092.728z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172409288346089329810000013221684186496424613_",
    gradientUnits: "userSpaceOnUse",
    x1: 1181.8507,
    y1: 908.5637,
    x2: 1399.33,
    y2: 60.0382,
    gradientTransform: "matrix(0.9977 0.0681 -0.0681 0.9977 345.4232 35.2827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172409288346089329810000013221684186496424613_)"
    },
    d: "M1356.292,1418.171 c0,0,3.886-56.949-44.218-50.696c-48.105,6.253-0.127,148.703,44.155,125.047L1356.292,1418.171z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001644449549066807810000003493703709797907600_",
    gradientUnits: "userSpaceOnUse",
    x1: 1049.377,
    y1: 2345.3701,
    x2: 2151.8574,
    y2: 2345.3701
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001644449549066807810000003493703709797907600_)"
    },
    d: "M1804.139,1804.554 c-0.271,1.318-43.939-7.908-64.868-15.055l-270.89,11.425l-79.064,29.569c-172.74,61.879-327.279,109.621-339.94,181.663 c6.299,138.95,144.511,717.511,191.432,889.083l753.414-49.136l156.139-842.782 C2167.781,1982.214,2031.888,1866.611,1804.139,1804.554z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005246861982984446200000013357325442678050439_",
    gradientUnits: "userSpaceOnUse",
    x1: 1450.5897,
    y1: 1792.2902,
    x2: 1759.9238,
    y2: 1792.2902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005246861982984446200000013357325442678050439_)"
    },
    d: "M1455.783,1762.349 c82.511,23.435,169.865,30.505,274.899-14.684c1.251-0.538,2.7,0.115,3.097,1.417l25.022,43.652 c1.853,3.232,1.379,7.299-1.183,10.004c-2.972,3.139-6.565,6.615-7.047,6.776c-128.393,42.927-245.941,29.63-299.134,1.648 c-0.567-0.298-0.889-0.901-0.844-1.54l3.162-45.849C1453.826,1762.759,1454.806,1762.072,1455.783,1762.349z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1685.884,1766.83c0,0,0.151,4.329,0.432,12.445c0.323,8.102,0.511,20.011,2.125,34.973 c1.771,14.854,5.392,33.048,8.293,53.944c3.177,20.896,6.324,44.514,9.541,70.317c6.244,51.621,12.353,112.003,16.769,176.862 c2.145,32.429,4.344,65.953,5.546,100.062c1.301,34.103,2.367,68.758,2.876,103.425c0.318,34.67,0.387,69.341-0.116,103.465 c-0.48,34.122-1.223,67.7-2.48,100.177c-0.541,16.239-1.287,32.204-2.073,47.823c-0.946,15.614-1.72,30.896-2.781,45.754 c-1.937,29.726-4.207,57.801-6.537,83.691c-1.105,12.95-2.416,25.339-3.596,37.124c-1.332,11.772-2.595,22.937-3.781,33.43 c-2.55,20.964-4.858,39.225-7.012,54.23c-1.993,15.027-3.962,26.775-5.197,34.8c-1.257,8.02-1.928,12.297-1.928,12.297 s0.504-4.3,1.448-12.364c0.956-8.061,2.347-19.883,3.942-34.947c3.376-30.107,7.281-73.211,10.957-124.986 c1.817-25.89,3.53-53.956,4.878-83.66c1.396-29.703,2.449-61.041,3.387-93.46c0.963-32.419,1.405-65.935,1.58-99.986 c0.202-34.055-0.191-68.65-0.797-103.235c-0.429-34.59-1.415-69.171-2.635-103.2c-1.306-34.025-2.701-67.51-4.494-99.891 c-1.766-32.385-3.948-63.662-6.189-93.309c-2.309-29.642-4.919-57.631-7.561-83.448c-2.748-25.798-5.468-49.44-8.261-70.326 c-1.344-10.447-2.685-20.225-4.03-29.262c-1.269-9.012-2.633-17.333-3.268-24.974c-1.31-15.209-1.237-27.149-1.387-35.264 c-0.108-8.112-0.165-12.438-0.165-12.438c-0.014-0.694,0.538-1.269,1.233-1.282 C1685.288,1765.604,1685.856,1766.15,1685.884,1766.83z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022538907211235582640000008120789738493343902_",
    gradientUnits: "userSpaceOnUse",
    x1: 988.5837,
    y1: 437.8079,
    x2: 1691.6952,
    y2: 1192.8878
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022538907211235582640000008120789738493343902_)"
    },
    d: "M1840.612,1218.695 c0,0,57.079,0,66.593,85.621s-95.135,123.674-95.135,123.674l-57.079-9.512l28.54-180.755L1840.612,1218.695z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109028546431810902750000014375030202822729389_",
    gradientUnits: "userSpaceOnUse",
    x1: 1913.1921,
    y1: 1638.5897,
    x2: 2505.5974,
    y2: 1142.7717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109028546431810902750000014375030202822729389_)"
    },
    d: "M1223.574,1897.574l57.635,512.308 l93.904,6.552l-38.257-563.223c-0.515-7.583-8.348-12.401-15.349-9.439l-88.32,37.366 C1226.698,1883.884,1222.786,1890.571,1223.574,1897.574z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025445181763286219250000011207761146735714977_",
    gradientUnits: "userSpaceOnUse",
    x1: 2128.3645,
    y1: 1876.8785,
    x2: 2726.1873,
    y2: 1376.5261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025445181763286219250000011207761146735714977_)"
    },
    d: "M1853.273,1829.822l-91.625,560.406 l91.72-2.184l119.639-517.01c1.516-6.549-2.094-13.199-8.412-15.496l-95.772-34.826 C1861.93,1818.205,1854.456,1822.583,1853.273,1829.822z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171719202496015901910000018313301580056035492_",
    gradientUnits: "userSpaceOnUse",
    x1: 2495.1604,
    y1: 1918.1852,
    x2: 3258.5039,
    y2: 1279.2993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000171719202496015901910000018313301580056035492_)"
    },
    points: "1270.228,2260.563  1890.301,2230.234 1967.81,3042.394 1212.939,3032.284 1214.603,2829.174  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115506748105521083740000010765181538787513491_",
    gradientUnits: "userSpaceOnUse",
    x1: 1754.7776,
    y1: 2680.0732,
    x2: 1724.1935,
    y2: 2799.2891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115506748105521083740000010765181538787513491_)"
    },
    d: "M1791.317,2814.173 c-52.707-6.024-144.207-39.414-173.613-83.531l149.045-47.498c23.822,28.303,55.806,47.658,96.634,57.325L1791.317,2814.173z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045581694272853563880000011952325063689574032_",
    gradientUnits: "userSpaceOnUse",
    x1: 1752.1876,
    y1: 2417.2625,
    x2: 2449.6873,
    y2: 2417.2625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045581694272853563880000011952325063689574032_)"
    },
    d: "M2137.431,1976.364 c-14.406,134.609-70.505,555.751-139.292,506.617c210.133,171.876,64.365,209.08-147.761,254.303 c-19.786,25.989-51.918,48.671-95.538,68.273c-3.922,1.763-3.368,7.504,0.829,8.441 C2531.842,2987.31,2653.836,2638.653,2137.431,1976.364z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1484.43,909.515c14.542-8.212,372.97-53.711,310.504-162.287 c-17.847-31.02-28.817-64.708-29.836-98.29c-2.243-73.701-36.176-188.009-223.782-193.685 c-132.02-3.996-192.268,40.047-219.143,87.392c-29.538,52.036-83.958,80.043-146.354,73.5 c-74.12-7.773-152.447,11.932-149.586,131.245c0.528,21.976-2.206,43.297-8.898,62.827 c-31.044,90.613-94.208,346.986,230.296,243.103c11.279-3.611,22.005-8.581,31.88-14.799L1484.43,909.515z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178190057141247135270000000236520469965066896_",
    gradientUnits: "userSpaceOnUse",
    x1: 995.2663,
    y1: 784.8241,
    x2: 1735.9939,
    y2: 784.8241,
    gradientTransform: "matrix(1.0089 -0.0065 -0.0065 1.0048 -9.4641 7.2316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178190057141247135270000000236520469965066896_)"
    },
    d: "M1470.633,970.273 c13.434-7.614,315.936-104.095,259.087-203.246c-16.242-28.328-26.139-59.141-26.878-89.917 c-1.626-67.542-32.179-172.116-204.822-176.204c-121.49-2.878-151.823,54.332-176.841,97.889 c-27.496,47.873-103.135,57.386-160.526,51.76c-68.175-6.684-140.386,11.843-138.463,121.19 c0.356,20.141-2.288,39.7-8.563,57.641c-29.113,83.242-88.774,318.612,210.524,221.462c10.402-3.377,20.305-7.996,29.431-13.755 L1470.633,970.273z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1179.76,935.738l97.081,265.405c94.394-174.244,419.597-270.526,543.769-196.543 l-150.683-275.16c-4.64-40.065-86.229-69.821-131.548-61.934c-117.266,20.407-226.93,72.478-328.623,157.767 C1172.981,856.115,1160.369,902.956,1179.76,935.738z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030468507294742355400000004664566783022355376_",
    gradientUnits: "userSpaceOnUse",
    x1: 1226.0626,
    y1: 928.3464,
    x2: 1798.4657,
    y2: 928.3464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030468507294742355400000004664566783022355376_)"
    },
    d: "M1233.43,932.304l74.707,225.223 c133.893-142.881,375.033-193.201,490.329-163.443l-143.34-242.238c-30.826-40.573-73.018-58.307-111.884-51.116 c-100.567,18.606-194.978,64.001-282.931,137.498C1228.504,864.806,1217.197,904.696,1233.43,932.304z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066516171799992657200000007236896397078547877_",
    gradientUnits: "userSpaceOnUse",
    x1: 1630.3739,
    y1: 2510.5732,
    x2: 1306.5699,
    y2: 3862.9319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066516171799992657200000007236896397078547877_)"
    },
    d: "M1181.005,2473.078l99.032,212.845 c6.819,14.656,19.922,25.466,35.625,29.301c223.94,54.696,429.661,53.969,668.943-8.899 c23.711-6.23,42.664-24.065,50.234-47.383l69.917-215.346L1181.005,2473.078z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128469813975644774760000003903120576449188763_",
    gradientUnits: "userSpaceOnUse",
    x1: 1637.3949,
    y1: 2476.5903,
    x2: 1625.1224,
    y2: 2760.554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128469813975644774760000003903120576449188763_)"
    },
    d: "M1445.815,2333.01 c0,0-47.441-15.073-75.043-2.599c-37.953,7.797-78.493,9.356-91.431,26.509c-22.427,7.277-95.744,16.633-93.156,41.582 c-7.763,21.311-81.943,73.808-16.389,98.237c65.555,24.429,53.479,53.017,104.37,55.616s209.602,47.819,274.294,35.865 c80.218,4.158,183.725,14.553,230.303-1.04c68.142-3.119,182-14.034,200.976-25.469c25.014-1.559,134.99-27.548,144.047-68.87 c20.701-34.305,0-51.667-10.351-60.528c-10.351-8.861-34.934-47.065-46.578-47.844c-11.645-0.78-82.806-30.565-129.384-33.215 c-46.578-2.65-87.981-35.395-161.73-33.836c-73.749,1.559-183.725-11.695-212.19-6.237 C1535.09,2316.637,1470.398,2311.959,1445.815,2333.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090271430343708244510000008221935113552952974_",
    gradientUnits: "userSpaceOnUse",
    x1: 1630.964,
    y1: 2280.8098,
    x2: 1609.6257,
    y2: 2774.5388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090271430343708244510000008221935113552952974_)"
    },
    d: "M1287.795,2379.982 c0,0,78.222-12.652,87.716-24.354c0,0,53.053-0.268,68.579-8.064c19.839,0,87.888-6.351,94.881-9.356 c6.993-3.005,84.531,10.396,121.621,8.836c37.09-1.559,87.119-3.638,138.01,8.316c50.891,11.955,71.592,4.158,121.621,17.672 c50.029,13.514,32.777,37.424,62.967,46.78c30.19,9.356,29.327,31.186,20.702,43.661s-45.716,8.836-62.967,25.989 c-17.251,17.153-53.479,20.271-94.019,27.028s-137.147-9.356-169.062,6.237c-31.915,15.593-131.109-18.712-177.687-8.836 c-46.578,9.876-115.197-38.469-178.55-33.785s-39.678-55.616-72.455-55.616S1277.272,2392.129,1287.795,2379.982z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134960518943302840230000010931119406492379038_",
    gradientUnits: "userSpaceOnUse",
    x1: 2135.8079,
    y1: 2309.4722,
    x2: 1491.6376,
    y2: 3100.334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134960518943302840230000010931119406492379038_)"
    },
    d: "M1937.473,2505.574 c0,0,62.104,28.068,46.578,36.904C1968.526,2551.314,1940.924,2508.693,1937.473,2505.574z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147198409054439204820000005261566084872161920_",
    gradientUnits: "userSpaceOnUse",
    x1: 2018.0884,
    y1: 2266.5896,
    x2: 1374.2404,
    y2: 3057.0557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147198409054439204820000005261566084872161920_)"
    },
    d: "M1787.388,2529.484 c0,0,26.739,48.339,0,42.102C1760.649,2565.348,1774.45,2514.411,1787.388,2529.484z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135665004848213645790000009761304622385142678_",
    gradientUnits: "userSpaceOnUse",
    x1: -8199.7646,
    y1: 8066.1831,
    x2: -9219.8203,
    y2: 9318.5273,
    gradientTransform: "matrix(-0.1342 -0.991 0.8607 -0.1166 -327.1172 -721.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135665004848213645790000009761304622385142678_)"
    },
    d: "M2026.35,2435.739 c0,0,65.456-21.602,60.136-4.907C2081.165,2447.525,2006.556,2445.222,2026.35,2435.739z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041997613133519906060000000295849399138388119_",
    gradientUnits: "userSpaceOnUse",
    x1: 1864.6204,
    y1: 2169.9478,
    x2: 1181.5737,
    y2: 3008.5388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041997613133519906060000000295849399138388119_)"
    },
    d: "M1570.023,2533.642 c0,0-12.938,60.294-25.014,43.141C1532.933,2559.631,1546.734,2508.693,1570.023,2533.642z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063635547497908148320000000768102574685458870_",
    gradientUnits: "userSpaceOnUse",
    x1: 1719.4601,
    y1: 2018.1974,
    x2: 944.8874,
    y2: 2969.157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063635547497908148320000000768102574685458870_)"
    },
    d: "M1344.895,2500.377 c0,0-50.028,34.633-60.379,43.305C1265.54,2541.439,1325.057,2478.027,1344.895,2500.377z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082359265987809297650000004758984596179919494_",
    gradientUnits: "userSpaceOnUse",
    x1: 1622.1472,
    y1: 1922.4038,
    x2: 794.7118,
    y2: 2938.2642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082359265987809297650000004758984596179919494_)"
    },
    d: "M1229.312,2429.688 c0,0-40.54,4.678-56.929,20.271C1155.995,2465.552,1206.886,2442.162,1229.312,2429.688z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174589808590732088810000003421737712136051630_",
    gradientUnits: "userSpaceOnUse",
    x1: 1626.1708,
    y1: 1948.1556,
    x2: 810.6989,
    y2: 2949.3279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174589808590732088810000003421737712136051630_)"
    },
    d: "M1280.832,2370.434 c0,0-15.545-10.915,0-10.135C1296.376,2361.078,1309.059,2377.346,1280.832,2370.434z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025414992576596357110000000253466140885365681_",
    gradientUnits: "userSpaceOnUse",
    x1: 1743.5128,
    y1: 2110.8459,
    x2: 1102.2231,
    y2: 2898.1711
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025414992576596357110000000253466140885365681_)"
    },
    d: "M1563.123,2316.897 c0,0,8.626,24.429,12.076,15.593C1578.649,2323.654,1577.786,2309.62,1563.123,2316.897z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137844600168594426620000014089559651872755092_",
    gradientUnits: "userSpaceOnUse",
    x1: 1909.5205,
    y1: 2142.0955,
    x2: 1143.903,
    y2: 3082.0608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137844600168594426620000014089559651872755092_)"
    },
    d: "M1753.317,2324.646 c0,0-18.976,18.24-7.763,18.24C1756.767,2342.885,1782.213,2315.241,1753.317,2324.646z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119076980353569743020000005163431689828334991_",
    gradientUnits: "userSpaceOnUse",
    x1: 2075.1292,
    y1: 2203.843,
    x2: 1210.9034,
    y2: 3264.8716
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119076980353569743020000005163431689828334991_)"
    },
    d: "M1962.008,2360.258 c0,0-53.862,10.47-38.336,11.882C1939.198,2373.552,1969.661,2367.352,1962.008,2360.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051378852875328648400000013780723040661687482_",
    gradientUnits: "userSpaceOnUse",
    x1: 1514.5562,
    y1: 2652.6541,
    x2: 1459.6091,
    y2: 2866.8354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051378852875328648400000013780723040661687482_)"
    },
    d: "M1349.954,2758.574 c14.797-44.627,42.23-84.366,102.327-111.462c46.117-15.029,39.718,9.142-9.827,65.514c73.687-1.54,142.951-0.09,189.992,16.379 c-39.269,46.674-127.709,85.38-244.041,119.564C1347.561,2831.742,1338.218,2800.111,1349.954,2758.574z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093149854486641755840000014007811933411736448_",
    gradientUnits: "userSpaceOnUse",
    x1: 743.4453,
    y1: 2428.8523,
    x2: 1410.8542,
    y2: 2428.8523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093149854486641755840000014007811933411736448_)"
    },
    d: "M1074.771,1968.5 c14.542,142.8,68.522,422.368,61.782,523.467c-161.376,148.946-75.627,238.387,212.542,259.968 c-10.23,30.99,20.854,61.75,59.725,87.538c3.326,2.206,2.395,7.332-1.5,8.204C629.046,3022.075,557.741,2631.59,1074.771,1968.5 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162321220456547934260000004884878124742832525_",
    gradientUnits: "userSpaceOnUse",
    x1: 1788.1565,
    y1: 1648.3983,
    x2: 1821.8568,
    y2: 2275.2158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 564.704,
    y: 3122.6,
    style: {
      fill: "url(#SVGID_00000162321220456547934260000004884878124742832525_)"
    },
    width: 2611.816,
    height: 118.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182514951952614712230000017140473632917609642_",
    gradientUnits: "userSpaceOnUse",
    x1: 1745.3853,
    y1: 3594.0938,
    x2: 1511.332,
    y2: 4585.3755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182514951952614712230000017140473632917609642_)"
    },
    d: "M3244.22,3172.976H488.462 c-9.752,0-17.658-7.906-17.658-17.658v-147.011c0-9.752,7.906-17.658,17.658-17.658H3244.22c9.752,0,17.658,7.906,17.658,17.658 v147.011C3261.878,3165.071,3253.972,3172.976,3244.22,3172.976z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108994758936436133010000005207194565434119339_",
    gradientUnits: "userSpaceOnUse",
    x1: 3256.8611,
    y1: 2255.9307,
    x2: 2812.0266,
    y2: 2660.3257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108994758936436133010000005207194565434119339_)"
    },
    d: "M2582.025,2902.755 c-341.328-55.655-580.403-65.658-561.46-181.833c1.523-9.342,4.842-18.259,9.789-26.708 c18.932-32.462,62.183-58.215,123.13-76.175c24.74-7.305,52.413-13.326,82.584-17.996c35.139-5.406,73.603-8.993,114.74-10.67 c27.186-1.07,55.744-2.715,85.094-2.023c48.843,1.053,100.203,6.277,154.204,8.374l0.259,0.042 c0.052,0.009,0.052,0.009,0.104,0.017l82.828,13.505c43.749,7.134,86.469,13.971,126.631,27.096 c0.364,0.059,1.063-3.003,1.026,0.17l0.052,0.006c6.158,0.733,12.155,2.314,18.102,3.749c0.623,0.102,1.282,0.346,1.894,0.511 c10.377,2.36,20.51,5.257,30.51,8.295c1.277,0.339,2.489,0.756,3.714,1.087c8.578,2.611,17.157,5.223,25.58,7.802 c0.559,0.163,1.119,0.324,1.68,0.481c49.629,14.531,95.782,30.778,137.589,48.193c27.944,11.598,53.922,23.82,77.666,36.345 c107.018,56.621,168.553,120.985,159.018,179.465c-0.277,1.698-0.594,3.323-1.017,4.931 C3228.706,3036.372,2918.475,2957.615,2582.025,2902.755z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088835411528748179730000003545249435307323028_",
    gradientUnits: "userSpaceOnUse",
    x1: 1826.759,
    y1: 3856.7278,
    x2: 4050.9324,
    y2: 1868.4506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088835411528748179730000003545249435307323028_)"
    },
    d: "M3038.237,2846.88 c-22.887-3.732-33.826-53.943-24.344-112.098c1.598-9.801,3.672-19.256,6.181-28.103c27.944,11.598,53.922,23.819,77.666,36.344 c-0.235,1.77-0.523,3.537-0.811,5.298C3087.447,2806.476,3061.176,2850.62,3038.237,2846.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022536712907264255660000014642322075245354158_",
    gradientUnits: "userSpaceOnUse",
    x1: 1690.2925,
    y1: 3704.074,
    x2: 3914.4617,
    y2: 1715.8004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022536712907264255660000014642322075245354158_)"
    },
    d: "M2822.746,2758.082 c-22.887-3.732-33.398-53.873-23.916-112.028c0.564-3.458,0.539-7.02,1.249-10.395c28.047,6.722,55.374,14.466,80.779,22.028 l-0.277,1.697C2871.099,2717.538,2845.684,2761.822,2822.746,2758.082z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035492157734900080830000009024156104087809170_",
    gradientUnits: "userSpaceOnUse",
    x1: 1569.8174,
    y1: 3569.293,
    x2: 3793.988,
    y2: 1581.0182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035492157734900080830000009024156104087809170_)"
    },
    d: "M2617.216,2684.323 c-19.721-3.216-30.555-41.003-27.109-88.6l0.259,0.042c0.052,0.009,0.052,0.009,0.104,0.017l80.597,13.142 C2659.265,2655.158,2636.988,2687.547,2617.216,2684.323z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009591885176702017400000010209616089377273493_",
    gradientUnits: "userSpaceOnUse",
    x1: 1462.0889,
    y1: 3448.7859,
    x2: 3686.2627,
    y2: 1460.5084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009591885176702017400000010209616089377273493_)"
    },
    d: "M2377.285,2685.448 c-20.759-3.385-31.671-44.939-26.477-96.076c27.186-1.07,55.744-2.715,85.094-2.023 C2426.348,2645.288,2400.172,2689.179,2377.285,2685.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143574820351997080740000010299072467602001817_",
    gradientUnits: "userSpaceOnUse",
    x1: -7902.0952,
    y1: 9341.6602,
    x2: -5677.9297,
    y2: 7353.3896,
    gradientTransform: "matrix(-0.1585 0.9722 -0.7722 -0.1259 1958.1409 -1161.2968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143574820351997080740000010299072467602001817_)"
    },
    d: "M2181.004,2680.273 c-15.933-2.598-26.071-27.662-27.519-62.236c24.74-7.305,52.413-13.326,82.584-17.996 C2224.589,2648.877,2201.451,2683.608,2181.004,2680.273z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013189185595486483670000009937347382867587255_",
    gradientUnits: "userSpaceOnUse",
    x1: 3904.9136,
    y1: -821.7275,
    x2: 4216.9795,
    y2: -821.7275,
    gradientTransform: "matrix(-0.0432 0.9991 -0.7903 -0.0342 2001.0659 -1186.0117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013189185595486483670000009937347382867587255_)"
    },
    d: "M2425.152,3050.283 c-349.333-15.098-590.557,3.54-585.397-115.846c0.415-9.6,2.683-18.988,6.642-28.099c15.135-34.998,55.487-66.153,114.536-91.58 c23.967-10.336,51.033-19.729,80.767-28.062c34.634-9.671,72.825-17.907,113.926-24.54c27.167-4.344,55.643-9.433,85.193-12.262 c49.164-4.806,101.353-5.71,155.82-10.083l0.265,0.011c0.053,0.002,0.053,0.002,0.106,0.005l84.771,3.664 c44.775,1.935,88.481,3.844,130.37,12.25c0.372,0.016,0.708-2.72,1.05,0.197h0.053c6.271,0,12.48,0.724,18.621,1.456 c0.637,0.028,1.328,0.12,1.963,0.213c10.7,1.133,21.219,2.798,31.622,4.66c1.322,0.188,2.589,0.445,3.858,0.631 c8.924,1.601,17.849,3.194,26.613,4.782c0.581,0.097,1.163,0.188,1.744,0.278c51.561,8.686,99.837,19.516,143.888,32.049 c29.439,8.335,56.979,17.533,82.312,27.306c114.201,44.22,183.66,101.709,181.063,161.805c-0.075,1.744-0.2,3.42-0.433,5.092 C3090.359,3107.288,2769.493,3065.165,2425.152,3050.283z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076601214217465029280000002822103608524542878_",
    gradientUnits: "userSpaceOnUse",
    x1: -4835.5488,
    y1: 11026.5332,
    x2: -5718.4663,
    y2: 12259.9209,
    gradientTransform: "matrix(-0.0432 0.9991 -0.7903 -0.0342 2001.0659 -1186.0117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076601214217465029280000002822103608524542878_)"
    },
    d: "M2876.524,2939.152 c-23.424-1.012-40.396-50.313-37.813-110.075c0.435-10.072,1.39-19.852,2.853-29.071c29.439,8.334,56.979,17.533,82.312,27.306 c-0.025,1.812-0.104,3.628-0.182,5.438C2921.11,2892.512,2900,2940.167,2876.524,2939.152z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093860431776571049100000008671319665329074329_",
    gradientUnits: "userSpaceOnUse",
    x1: -4732.3145,
    y1: 11100.4053,
    x2: -5615.229,
    y2: 12333.7891,
    gradientTransform: "matrix(-0.0432 0.9991 -0.7903 -0.0342 2001.0659 -1186.0117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093860431776571049100000008671319665329074329_)"
    },
    d: "M2649.577,2875.528 c-23.424-1.012-39.958-50.294-37.375-110.056c0.154-3.554-0.297-7.141,0.013-10.629c28.961,3.406,57.321,7.93,83.73,12.5 l-0.075,1.744C2693.287,2828.849,2673.054,2876.542,2649.577,2875.528z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127754593268038641730000015685992429611726469_",
    gradientUnits: "userSpaceOnUse",
    x1: 2759.5352,
    y1: 2310.7893,
    x2: 1876.6046,
    y2: 3544.1946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127754593268038641730000015685992429611726469_)"
    },
    d: "M2434.426,2825.867 c-20.183-0.872-35.568-37.662-37.787-86.056l0.265,0.011c0.053,0.002,0.053,0.002,0.106,0.005l82.487,3.565 C2473.164,2791.416,2454.662,2826.741,2434.426,2825.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116953513497547025400000002838317441441499796_",
    gradientUnits: "userSpaceOnUse",
    x1: 2612.646,
    y1: 2205.6396,
    x2: 1729.7156,
    y2: 3439.0449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116953513497547025400000002838317441441499796_)"
    },
    d: "M2193.67,2855.824 c-21.246-0.918-37.159-41.495-38.044-93.668c27.167-4.344,55.643-9.433,85.193-12.262 C2238.139,2809.448,2217.093,2856.836,2193.67,2855.824z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098939823514136472900000014992547547249269425_",
    gradientUnits: "userSpaceOnUse",
    x1: -4316.9302,
    y1: 11397.6318,
    x2: -5199.8418,
    y2: 12631.0098,
    gradientTransform: "matrix(-0.0432 0.9991 -0.7903 -0.0342 2001.0659 -1186.0117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098939823514136472900000014992547547249269425_)"
    },
    d: "M1995.986,2874.188 c-16.306-0.705-29.475-24.753-35.053-59.43c23.967-10.336,51.033-19.729,80.767-28.062 C2036,2837.303,2016.913,2875.093,1995.986,2874.188z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotSupport);
export default __webpack_public_path__ + "static/media/kot_support.9349c09be217953703ca259abbc289a2.svg";
export { ForwardRef as ReactComponent };